import { apiClient } from '@/services/apiClient';
import type { PriceBreakdown } from '@/types/checkout';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import { Routes } from './routes';
import { CheckoutContext } from '@/context/CheckoutContext';

interface CalculateEstimatedTaxResponse {
  isValid: boolean;
  priceBreakdown: PriceBreakdown;
  zipCode: string;
  state: string;
}

export const useCalculateTax = () => {
  return useMutation({
    mutationFn: async ({ address, zipCode }: { address: string; zipCode: string }) => {
      const results = await apiClient.get<CalculateEstimatedTaxResponse>(
        `${Routes.CALCULATE_TAX}?address=${address}&zipCode=${zipCode}`
      );
      return results;
    },
  });
};

export const useCalculateTaxByZipCode = () => {
  // Subscription checkout estimates tax on its own (un-versioned) endpoint;
  // resolving it here lets ZipCode/InputTaxComponent be reused unchanged.
  const { subscription } = useContext(CheckoutContext);
  const taxRoute = subscription ? Routes.SUBSCRIPTION_TAX : Routes.CALCULATE_TAX;
  return useMutation({
    mutationFn: async ({ zipCode }: { zipCode: string }) => {
      const results = await apiClient.get<CalculateEstimatedTaxResponse>(`${taxRoute}?zipCode=${zipCode}`);
      return results;
    },
  });
};

export const useHandleDefaultTax = () => {
  return useMutation({
    mutationFn: async () => {
      const results = await apiClient.get<CalculateEstimatedTaxResponse>(Routes.HANDLE_DEFAULT_TAX);
      return results;
    },
  });
};
